module.exports = __webpack_public_path__ + "img/inbox.8c4dd353.svg";